import { TagTextAlert, TextExternalLink, Span } from "@bridgesplit/ui";

interface SwapRouteErrorAlertProps {
    linkText: string;
}

export function SwapRouteErrorAlert({ linkText }: SwapRouteErrorAlertProps) {
    return (
        <TagTextAlert color="error" icon="warning">
            <Span>
                Unable to find a swap route through our integration partners. Please check back later or{" "}
                <TextExternalLink
                    href={"https://docs.loopscale.com/using-loopscale/loop#manually-close-a-loop"}
                    sx={{ color: "secondary.main", display: "inline" }}
                    isPrimary
                    underlineLink
                >
                    {linkText}
                </TextExternalLink>
            </Span>
        </TagTextAlert>
    );
}
